var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLinked = function SvgLinked(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    viewBox: "0 0 100 100",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "linked_svg__a",
    width: 100,
    height: 100,
    x: -0.1,
    y: -0.1,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "linked_svg__b",
    width: 100,
    height: 100,
    x: -0.1,
    y: -0.1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#linked_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.1-.1h100v100H-.1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m24.6 79.8-5.2-5.5 55-55 5.6 5.8zm68.7-41.9c8.7-8.7 8.7-22.9 0-31.7-8.4-8.4-23.1-8.4-31.7 0L39.1 28.9l8.3 8.3 22.7-22.7c4.1-4.1 11.1-4.1 15.1 0 4.2 4.2 4.2 10.9 0 15.1L62.3 52.3l8.3 8.3zM38.1 93.1l22.7-22.7-8.4-8.1-22.6 22.6c-4.1 4.1-11.1 4.1-15.1 0-4.2-4.2-4.2-10.9 0-15.1L37.4 47l-8.3-8.3L6.4 61.6c-8.7 8.7-8.7 22.9 0 31.7 4.2 4.2 9.8 6.6 15.8 6.6 5.9-.2 11.7-2.6 15.9-6.8",
    style: {
      mask: "url(#linked_svg__b)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLinked);
export default ForwardRef;